import { animate, state, style, transition, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { LaravelResourceResponse } from '../../../../../../../../../_base-shared/contracts/laravel-response.interface';
import { Case } from '../../../../../../../../../_base-shared/models/Case/Case';
import { CaseCreditorPivot } from '../../../../../../../../../_base-shared/models/Case/CaseCreditor';
import { PaymentMethod } from '../../../../../../../../../_base-shared/models/Payment/PaymentMethod';
import { PaymentTerm } from '../../../../../../../../../_base-shared/models/Payment/PaymentTerm';
import { PaymentPlanType } from '../../../../../../../../../_base-shared/models/Product/PaymentPlanType';
import { User } from '../../../../../../../../../_base-shared/models/User/User';
import { environment } from '../../../../../../../environments/environment';
import {
  ChangeAmountModalComponent
} from '../../../../../../_shared/components/change-amount-modal/change-amount-modal.component';
import {
  ChangeDateModalComponent
} from '../../../../../../_shared/components/change-date-modal/change-date-modal.component';
import { MainGlobalEventService } from '../../../../../../_shared/services/main-global-event.service';
import { DistributionService } from '../../../../../distribution/distribution.service';
import { PaymentMethodService } from '../../../../../payment/payment-method.service';
import { PaymentPlanTypeService } from '../../../../../payment/payment-plan-type.service';
import { PaymentService } from '../../../../../payment/payment.service';
import { CaseDocumentService } from '../../../../case-document.service';
import {
  CaseInstallmentAmountEditorComponent
} from '../../case-installment-amount-editor/case-installment-amount-editor.component';
import { AppSelectOption } from '../../../../../../../../../_base-shared/contracts/common.interface';

@Component({
  selector:    'app-upcoming-installment-list',
  templateUrl: './upcoming-installment-list.component.html',
  styleUrls:   ['./upcoming-installment-list.component.scss'],
  standalone:   false,
  animations:  [
    trigger('detailExpandDS', [
      state('collapsed', style({display: 'none', minHeight: '0'})),
      state('expanded', style({display: 'block'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('detailExpand', [
      state('collapsed', style({display: 'none', minHeight: '0'})),
      state('expanded', style({display: 'block'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class UpcomingInstallmentListComponent implements OnInit {
  @Input() componentType: 'distribution' | 'admin';
  @Input() case: Case;
  @Input() openRecordPaymentDialog: EventEmitter<any>;
  @Input() fetchInstalments: EventEmitter<any>;
  @Output() paymentRecorded: EventEmitter<any>                 = new EventEmitter<any>();
  @Output() selectionChanged: EventEmitter<any>                = new EventEmitter<any>();
  @Output() installmentPlanTypeGroupChanged: EventEmitter<any> = new EventEmitter<Array<string>>();
  @ViewChild('changeValueModal') valueModal: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public appEnv: string;
  public upcomingInstallments: Array<PaymentTerm>         = [];
  public unpaidInstallments                               = [];
  public displayedColumns: Array<string>                  = [];
  public displayedColumnsChildInstallments: Array<string> = [];
  public installmentsPlanTypeSlugsControl                 = new UntypedFormControl(['debt_plan'], [Validators.required]);
  public installmentsPlanTypeGroupsControl                = new UntypedFormControl(['debt_plan'], [Validators.required]);
  public paymentPlanTypeGroups: Array<AppSelectOption>;
  public dataSource: MatTableDataSource<PaymentTerm>;
  public dataSourceUnpaid: MatTableDataSource<PaymentTerm>;
  public recordForm: UntypedFormGroup;
  public totalResults: number;
  public showOnlyUnpaid                                   = false;
  public sortOrder                                        = null;
  public sortBy                                           = null;
  public filteredInstallmentsBalance                      = {
    totalPaid:        0,
    totalToPay:       0,
    totalPaidCounter: 0,
    totalDistributed: 0,
  };
  public debtPlanInstallmentsBalance                      = {
    totalPaid:  0,
    totalToPay: 0,
  };
  public additionalPlansInstallmentsBalance               = {
    totalPaid:  0,
    totalToPay: 0,
  };
  public paginatorConfig                                  = {
    pageIndex: 0,
    pageSize:  10,
    length:    1,
  };
  public now                                              = new Date(new Date().setHours(0, 0, 0, 0));
  public days                                             = [];
  public isLoading                                        = 0;
  public authUser: User;
  public paymentMethods: Array<PaymentMethod>;
  public paymentPlanTypes: Array<PaymentPlanType>;
  private forceDefaultProcessor                           = false;
  public selectionInstallments                            = new SelectionModel<any>(true, []);
  public selectionPaymentsDisabled                        = true;
  public onlyDebtPlanSelected                             = true;
  public isSubmitting: boolean;

  public expandedRow: number;
  public expandedElement: CaseCreditorPivot | null;
  public expandedElementDS: any;
  public templateData: Array<any>    = [];
  public creditorsMerged: Array<any> = [];
  public isProductDS                 = true;

  public authorizedUsers             = [27, 751562, 751600, 752733];
  //public excludedStatuses: number[] = [11,14,15,19,24,25,26,27,33,36];
  public excludedProductId: number[] = [18];
  public allowedFundsTransfer        = [1, 27, 752900, 751600, 36, 751562];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private translate: TranslateService,
    private globalEventsService: MainGlobalEventService,
    private paymentService: PaymentService,
    private distributionService: DistributionService,
    private paymentMethodService: PaymentMethodService,
    private paymentPlanTypeService: PaymentPlanTypeService,
    private caseDocumentService: CaseDocumentService
  ) {
    this.appEnv = environment.APP_ENV;
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(result => {
      const stateParams    = new URLSearchParams(result);
      const paymentOutcome = stateParams.get('payment_outcome');
      if (paymentOutcome === 'success' || paymentOutcome === 'error' || paymentOutcome === 'cancelled') {
        const paymentSuccess = paymentOutcome === 'success';
        let title: string;
        let message: string;
        if (paymentOutcome === 'success') {
          title   = this.translate.instant('SHARED-COMPONENTS.payment_outcome.success.heading');
          message = this.translate.instant('SHARED-COMPONENTS.payment_outcome.success.message');
        } else if (paymentOutcome === 'cancelled') {
          title   = this.translate.instant('SHARED-COMPONENTS.payment_outcome.cancelled.heading');
          message = this.translate.instant('SHARED-COMPONENTS.payment_outcome.cancelled.message');
        } else {
          title   = this.translate.instant('SHARED-COMPONENTS.payment_outcome.error.heading');
          message = this.translate.instant('SHARED-COMPONENTS.payment_outcome.error.message');
        }
        Swal.fire({
          title,
          text:               message,
          icon:               paymentSuccess ? 'success' : 'error',
          showCancelButton:   false,
          showConfirmButton:  true,
          cancelButtonText:   this.translate.instant('SHARED.cancel'),
          confirmButtonColor: '#886ab5',
        }).then(res => {
          if (res.isConfirmed) {
            this.router.navigate([], {queryParams: {payment_outcome: null}, queryParamsHandling: 'merge'});
          }
        });

      }
    });
    this.globalEventsService.authUser$.subscribe(user => {
      this.authUser                          = user;
      this.displayedColumns                  = this.getTableColumns(this.componentType);
      this.displayedColumnsChildInstallments = this.getChildInstallmentsTableColumns();
      this.fetchInstallments(this.componentType);
      this.fetchPaymentPlanTypes(this.componentType);
      this.paymentPlanTypeGroups = this.getPaymentPlanTypeGroups();
      //  Get total amount of paid terms and total amount to pay
      this.case.terms.forEach(term => {
        this.filteredInstallmentsBalance.totalToPay += term.amount;
        this.filteredInstallmentsBalance.totalPaid += term.amount_paid;
        this.filteredInstallmentsBalance.totalPaidCounter += this.filteredInstallmentsBalance.totalPaidCounter;
        if (term.case_plan_id === this.case.debt_payment_plan.id) {
          this.debtPlanInstallmentsBalance.totalToPay += term.amount;
          this.debtPlanInstallmentsBalance.totalPaid += term.amount_paid;
        }
        if (term.case_plan_id !== this.case.debt_payment_plan.id) {
          this.additionalPlansInstallmentsBalance.totalToPay += term.amount;
          this.additionalPlansInstallmentsBalance.totalPaid += term.amount_paid;
        }
      });
    });

    this.installmentsPlanTypeGroupsControl.valueChanges.subscribe(value => {
      this.planTypeGroupsUpdated(value);
    });

    this.installmentsPlanTypeSlugsControl.valueChanges.subscribe(value => {
      this.fetchInstallments(this.componentType);
    });

    //  Generate days array
    for (let i = 1; i <= 31; i++) {
      this.days.push(i);
    }

    this.selectionInstallments.changed.subscribe(next => {
      this.checkIfDisabled(next);
    });

    //better to calculate if phase1 or 2 using variables than calling from the template
    //this.monthsRemaining = this.getMonthsRemaining();
    this.templateData.push(this.viewCalculations());

    let creditors     = this.case.unsecured_creditors
    //const cred_unifye = this.case.creditors.find(creditor => creditor.id === 2817);
    const cred_unifye = this.case.creditors.find(creditor => creditor.name === 'UNIFYE');
    if (cred_unifye) {
      creditors.push(cred_unifye);
    }
    //not grouping for now, delete it ?  DAM
    //this.creditorsMerged = this.groupByNameAndCollectValues(creditors);
    this.creditorsMerged = creditors
    //console.log(this.creditorsMerged);

  }

  private groupByNameAndCollectValues(data: any[]) {
    // Initialize a map to store grouped data
    const map = new Map<string, any>();

    // Iterate through the data to group and collect values
    data.forEach(item => {
      const key = item.name;
      if ( ! map.has(key)) {
        map.set(key, {name: item.name, offer_to_creditor_values: [], total_offer_to_creditor: 0});
        // map.set(key, { ...item, pivot: { ...item.pivot, t_offer_to_creditor: 0 } });
      }
      const group = map.get(key);
      group.offer_to_creditor_values.push(item.pivot.offer_to_creditor);
      group.total_offer_to_creditor += item.pivot.offer_to_creditor;
    });

    // Convert the map values to an array
    return Array.from(map.values());
  }

  private checkIfDisabled(data) {
    data.added.forEach(payment => {
      if (payment.case_payment_plan.type.slug === 'debt_plan') {
        this.selectionPaymentsDisabled = true;
        if (this.authorizedUsers.includes(this.authUser.id)) {
          this.selectionPaymentsDisabled = false;
        }
      } else {
        this.selectionPaymentsDisabled = false;
      }
    });
    this.selectionChanged.emit(this.selectionPaymentsDisabled);
  }

  public fetchInstallments(componentType: 'admin' | 'distribution') {
    const data = {
      per_page:        this.paginatorConfig.pageSize,
      page:            this.paginatorConfig.pageIndex + 1,
      case_id:         this.case.id,
      select_all:      1,
      order:           this.sortOrder || 'asc',
      sort_by:         this.sortBy || 'term_date',
      plan_type_slugs: this.installmentsPlanTypeSlugsControl.value ? this.installmentsPlanTypeSlugsControl.value : [],
    };

    const withRelations = [
      'case.client',
      'case.debt_payment_plan',
      'distribution_case_terms',
      //'case.terms',
      'distribution_case_terms.batches',
      'case.payment_status',
      'case_payment_plan.type',
      'case.distribution',
      'child_installments.case_payment_plan.type'
    ];
    const observable    = componentType === 'admin' ?
      this.paymentService.indexCaseInstallments(this.case.id, data, withRelations) :
      this.distributionService.indexInstallments(this.case.uuid, data, withRelations);

    this.isLoading++;
    this.dataSource           = new MatTableDataSource<PaymentTerm>([]);
    this.upcomingInstallments = [];
    observable.pipe(finalize(() => this.isLoading--))
      .subscribe(
        res => this.handleResponse(res),
        error => console.log(error),
      );
  }

  public saveTermId(installment: PaymentTerm) {
    const dialogRef = this.dialog.open(ChangeDateModalComponent, {
      width: '50%',
      data:  {
        term: installment,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchInstallments(this.componentType);
      }
    });
  }

  public toggleRow(element: any) {
    element.expanded = ! element.expanded;
  }

  public showHideUnpaid($event) {
    this.paginator.firstPage();
    if ($event.checked) {
      this.paginatorConfig.length = this.unpaidInstallments.length;
    } else {
      this.paginatorConfig.length = this.upcomingInstallments.length;
    }
    this.showOnlyUnpaid = $event.checked;
  }

  public sortData(sort) {
    this.sortOrder = sort.direction !== '' ? sort.direction : null;
    this.sortBy    = sort.direction !== '' ? sort.active : null;

    this.fetchInstallments(this.componentType);
  }

  public openChangeAmountModal(installment: PaymentTerm) {
    const dialogRef = this.dialog.open(ChangeAmountModalComponent, {
      width: '50%',
      data:  {
        term: installment,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchInstallments(this.componentType);
      }
    });
  }

  public openAdditionalAmountEditorModal(installment: PaymentTerm) {
    const dialogRef = this.dialog.open(CaseInstallmentAmountEditorComponent, {
      width: '50%',
      data:  {
        installment,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.fetchInstallments(this.componentType);
    });
  }

  public buildForm() {
    const defaultPaymentMethod = this.paymentMethods.find(m => m.slug === 'sepa');
    const defaultIncomeAccount = defaultPaymentMethod.billing_bank_accounts.find(account => account.default === true);
    const defaultPlanId        = this.paymentPlanTypes.find(planType => planType.slug === 'debt_plan');

    this.recordForm = this.fb.group({
      case_id:           this.case.id,
      payment_plan_id:   defaultPlanId?.id ? defaultPlanId.id : null,
      note:              '',
      payment_date:      [new Date()],
      payment_method_id: [defaultPaymentMethod.id],
      payment_method:    [defaultPaymentMethod.slug],
      income_account_id: [defaultIncomeAccount.id, Validators.required],
      split_type:        ['custom', null],
      amount:            [0, Validators.required],
      amount_paid:       [null, Validators.required],
      phase_one_amount:  [0, null],
      phase_two_amount:  [0, null],
      phase_one_paid:    [
        this.upcomingInstallments.filter(
          term => (term.type === null || term.type === 'phase_one' || term.type === 'deferred_one') && term.amount >
            term.amount_paid).length === 0, null],
      phase_two_paid:    [
        this.upcomingInstallments.filter(
          term => (term.type === 'phase_two' || term.type === 'deferred_two') && term.amount >
            term.amount_paid).length === 0, null],
      terms:             this.fb.array([]),
      terms_phase_one:   this.fb.array(
        this.upcomingInstallments.filter(
          term => term.type === null || term.type === 'phase_one' || term.type === 'deferred_one'),
      ),
      terms_phase_two:   this.fb.array(this.upcomingInstallments.filter(term => term.type === 'phase_two')),
    });
    this.addInstalments();
    this.calculateAmountPaid();
  }

  addInstalments() {
    const instalments = this.recordForm.get('terms') as UntypedFormArray;
    this.upcomingInstallments.forEach(term => {
      instalments.push(
        this.fb.group({
          id:              term.id,
          term_date:       term.term_date,
          date_paid:       term.date_paid,
          type:            term.type,
          name:            term.name,
          amount:          term.amount,
          amount_paid:     0,
          old_amount_paid: term.amount_paid,
        }),
      );
    });
  }

  calculateAmountPaid() {
    let phaseOneAmount = 0;
    let phaseTwoAmount = 0;
    let amountPaid     = 0;
    let amountPayable  = 0;
    this.upcomingInstallments.forEach(term => {
      amountPayable += term.amount - term.amount_paid;
      amountPaid += term.amount_paid;
      if (term.type === null || term.type === 'phase_one' || term.type === 'deferred_one') {
        phaseOneAmount += term.amount - term.amount_paid;
      } else if (term.type === 'phase_two' || term.type === 'deferred_two') {
        phaseTwoAmount += term.amount - term.amount_paid;
      }
    });
    amountPayable = +amountPayable.toFixed(2);
    this.recordForm.get('phase_one_amount').setValue(phaseOneAmount);
    this.recordForm.get('phase_two_amount').setValue(phaseTwoAmount);
    this.recordForm.get('amount_paid').setValue(amountPaid);
    this.recordForm.get('amount').setValidators([Validators.required, Validators.max(Math.min(amountPayable, 4000))]);
  }

  public getDistributionSchedule(term, previousDistributionDate = null) {

    if (term.type === "phase_one") {
      return null;
    }

    const currentDate = new Date();
    const termDate    = new Date(term.term_date);
    const datePaid    = term.date_paid ? new Date(term.date_paid) : null;

    const currentNextMont = new Date();
    currentNextMont.setMonth(currentNextMont.getMonth() + 1);

    // Set distribution to the 15th of the month following termDate
    let distributionDate = new Date(termDate.getFullYear(), termDate.getMonth() + 1, 15);

    // If there's a previous distribution date (due to an unpaid installment), use it
    if (previousDistributionDate) {
      const previousDate = new Date(previousDistributionDate);

      // Only update if the previous distribution date is not in the same month
      if (previousDate.getMonth() !== termDate.getMonth()) {
        distributionDate = new Date(previousDate.getFullYear(), previousDate.getMonth() + 1, 15);

        // If no payment is made, return the calculated distribution date
        if ( ! datePaid) {
          return distributionDate;
        }

        // If a payment is made, adjust the distribution based on the payment date
        distributionDate = new Date(datePaid.getFullYear(), datePaid.getMonth() + 1, 15);
      }
    }

    // Handle the case where date_paid is between the 1st and 5th of the next month
    const nextMonth        = new Date(distributionDate.getFullYear(), distributionDate.getMonth(), 1);
    const fifthOfNextMonth = new Date(distributionDate.getFullYear(), distributionDate.getMonth(), 7); //requested change to 7 temporarly

    // Payment after the 5th of the next month -> shift distribution date one month further
    if (datePaid && datePaid > fifthOfNextMonth) {
      distributionDate = new Date(distributionDate.getFullYear(), distributionDate.getMonth() + 1, 15);
      return distributionDate;
    }

    // Payment is made before or on the 5th of the next month -> keep the next month's 15th
    if (datePaid && datePaid >= nextMonth && datePaid <= fifthOfNextMonth) {
      return distributionDate;
    }

    // No payment made, return the distribution date based on the current date or previous date
    if ( ! datePaid) {
      distributionDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 15);
      if (previousDistributionDate) {
        const previousDate = new Date(previousDistributionDate);
        if (previousDate.getTime() >= distributionDate.getTime()) {
          distributionDate = new Date(previousDate.getFullYear(), previousDate.getMonth() + 1, 15);
        }
      }
      return distributionDate;
    }

    //when previous is larger than current and payment is done between 1-5 next month
    if (datePaid && previousDistributionDate && previousDistributionDate > currentNextMont) {
      //const previousDate = new Date(previousDistributionDate);
      const fifthOfNextMonth = new Date(datePaid.getFullYear(), datePaid.getMonth(), 7); //requested change to 7 temporarly

      if (datePaid <= fifthOfNextMonth) {
        distributionDate = new Date(datePaid.getFullYear(), datePaid.getMonth(), 15);
      } else {
        distributionDate = new Date(datePaid.getFullYear(), datePaid.getMonth() + 1, 15);
      }
    }

    return distributionDate;
  }

  public handleResponse(response: LaravelResourceResponse) {
    //  Get total amount of paid terms and total amount to pay
    this.filteredInstallmentsBalance.totalToPay       = 0;
    this.filteredInstallmentsBalance.totalPaid        = 0;
    this.filteredInstallmentsBalance.totalPaidCounter = 0;
    this.filteredInstallmentsBalance.totalDistributed = 0;

    let totalTermDistribution: number = 0;
    let totalTermDisburse: number     = 0;
    let term_distributed_at: Date     = null;
    let term_disbursed_at: Date       = null;
    let previousDistributionDate      = null;


    response.data.forEach(term => {
      totalTermDistribution = 0;
      totalTermDisburse     = 0;
      term_distributed_at   = null;
      term_disbursed_at     = null;

      this.filteredInstallmentsBalance.totalToPay += term.amount;
      this.filteredInstallmentsBalance.totalPaid += term.amount_paid;
      this.filteredInstallmentsBalance.totalPaidCounter += this.filteredInstallmentsBalance.totalPaidCounter;

      term.distribution_case_terms.forEach(dist => {

        const isTermInDistribution = term.case.distribution.some((caseDist: any) =>
          caseDist.distribution_batch_id === dist.batches.id
        );

        if ( ! isTermInDistribution) {
          console.log(`Batch ID ${dist.batches.id} is not in term.case.distribution`);
          return;
        }

        this.filteredInstallmentsBalance.totalDistributed += dist.amount_distributed;
        totalTermDistribution += dist.amount_distributed;
        if (dist.disbursed) {
          totalTermDisburse += dist.amount_distributed;
        }
        if (term.id === dist.term_id &&
          dist.distributed_at != null &&
          dist.distributed_at !== undefined
          && dist.distributed_at !== '') {
          term_distributed_at = dist.distributed_at;
        }
        if (term.id === dist.term_id &&
          dist.disbursed_at != null &&
          dist.disbursed_at !== undefined
          && dist.disbursed_at !== '') {
          term_disbursed_at = dist.disbursed_at;
        }
      });
      term.total_distributed_amount = totalTermDistribution;
      term.total_disbursed_amount   = totalTermDisburse;
      term.distribution_schedule    = this.getDistributionSchedule(term, previousDistributionDate);
      previousDistributionDate      = term.distribution_schedule;
      term.distributed_at           = term_distributed_at;
      term.disbursed_at             = term_disbursed_at;
      term.offer_to_creditors_total = Number(this.case.expense.offer_to_creditors_total);
      term.distribution_fee         = Number(this.case.expense.distribution_fee);

    });

    const onlyUnpaid = response.data.filter(obj => obj.amount !== obj.amount_paid);

    this.totalResults         = response.data.total;
    this.upcomingInstallments = response.data;
    this.unpaidInstallments   = onlyUnpaid;

    const installments = response.data.map(installment => {
      return {
        ...installment,
        child_installments_source: new MatTableDataSource<PaymentTerm>(installment.child_installments)
      };
    });

    this.dataSource                 = new MatTableDataSource<PaymentTerm>(installments);
    this.dataSourceUnpaid           = new MatTableDataSource<PaymentTerm>(onlyUnpaid);
    this.dataSource.paginator       = this.paginator;
    this.dataSource.sort            = this.sort;
    this.dataSourceUnpaid.paginator = this.paginator;
    this.dataSourceUnpaid.sort      = this.sort;
    this.paginatorConfig.length     = response.data.length;
  }

  public getPercent(paid, amount) {
    if ((paid / amount) * 100) {
      return ((paid / amount) * 100).toFixed(2);
    } else {
      return 0;
    }
  }

  private fetchPaymentMethods(componentType: 'admin' | 'distribution'): void {
    if (componentType === 'distribution') {
      this.paymentMethods = [];
      return;
    }
    this.isLoading++;
    this.paymentMethodService.index({}, ['billing_bank_accounts']).pipe(finalize(() => this.isLoading--))
      .subscribe(result => {
        this.paymentMethods = result.data;
        this.buildForm();
      });
  }

  private fetchPaymentPlanTypes(componentType: 'distribution' | 'admin') {
    this.isLoading++;
    this.paymentPlanTypeService.index().pipe(finalize(() => this.isLoading--))
      .subscribe(result => {
        let data              = result.data.filter(planType => ! ['claim_fee', 'asnef_fee', 'annual_review_fee'].includes(planType.slug));
        this.paymentPlanTypes = componentType === 'admin' ?
          data :
          data.filter(planType => planType.default === true);
        this.fetchPaymentMethods(this.componentType);
      });
  }

  private getTableColumns(type: 'distribution' | 'admin'): Array<string> {
    const columns = [
      'select',
      'client-name',
      //'email',
      'name',
      'next-payment',
      'date-paid',
      'amount',
    ];
    if (type === 'admin') {
      columns.push('actions');
    }

    if (this.isPhaseOne() || this.isPhaseTwo()) {
      columns.push('newColSeparator');
      columns.push('dist-schedule');
      columns.push('dist-paid');
    }

    if (this.isPhaseTwo()) {
      columns.push('amountDistributed');
      columns.push('showDistribution');
    }

    return columns;
  }

  private getChildInstallmentsTableColumns(): Array<string> {
    return [
      'name',
      'next-payment',
      'date-paid',
      'amount',
      'actions'
    ];
  }

  public deleteInstallment(termId: number) {
    Swal.fire({
      title:              this.translate.instant('SHARED.warning'),
      text:               this.translate.instant('SHARED.action.delete_confirmation',
        {model: this.translate.instant('INSTALLMENTS.model_name.singular')}),
      icon:               'warning',
      showCancelButton:   true,
      confirmButtonText:  this.translate.instant('SHARED.delete'),
      cancelButtonText:   this.translate.instant('SHARED.cancel'),
      confirmButtonColor: '#886ab5',
    }).then(res => {
      if (res.isConfirmed) {
        this.isLoading++;
        this.dataSource = new MatTableDataSource<PaymentTerm>([]);

        this.paymentService.deleteCaseInstallment(this.case.id, termId).pipe(finalize(() => this.isLoading--))
          .subscribe(
            value => {
              this.fetchInstallments(this.componentType);
              this.toastr.success(this.translate.instant('SHARED.submit_result.delete.success', {
                model: this.translate.instant('INSTALLMENTS.model_name.singular'),
              }));
            },
            error => {
              this.toastr.error(this.translate.instant('SHARED.submit_result.delete.error', {
                model: this.translate.instant('INSTALLMENTS.model_name.singular'),
              }));
            },
          );
      }
    });
  }

  public markAsPromo(installment: PaymentTerm) {
    this.isLoading++;
    this.paymentService.caseInstallmentMarkAsPromo(this.case.id, installment.id).pipe(finalize(() => this.isLoading--))
      .subscribe(
        result => {
          this.toastr.success(this.translate.instant('SHARED.submit_result.update.success', {
            model: this.translate.instant('INSTALLMENTS.model_name.singular'),
          }));
        },
        error => {
          this.toastr.error(this.translate.instant('SHARED.submit_result.update.error', {
            model: this.translate.instant('INSTALLMENTS.model_name.singular'),
          }));
        }
      );
  }

  public isPhaseTwo() {
    const phaseTwoStatusIds = [335, 507];
    //const enabledRoles = environment.ALLOW_CASES_ROLES_IDS;

    if (
      this.userIsAMami() &&
      this.case.status_id === phaseTwoStatusIds[1] &&
      this.case.distribution_case_terms.length > 0) {
      return true;
    }
    return this.case.status_id === phaseTwoStatusIds[0];
  }

  public userIsAMami(): boolean {
    return environment.DISTRIBUTION_USER_IDS.includes(this.authUser.id);
  }

  public isPhaseOne() {
    const phaseTwoStatusIds = [411, 383, 394, 113];
    return phaseTwoStatusIds.includes(this.case.status_id);
  }

  public viewCalculations() {
    //months pending to pay
    let totalMonthsToPay: number = this.case.terms.length;
    let fee                      = this.case.expense.distribution_fee;
    let feesPaid                 = 0;
    let totalMonthsFullyPaid     = 0;
    let totalDebtAmount          = 0;
    let totalFinalPayments       = 0;
    let totalCreditorsOffer      = 0;
    this.case.terms.forEach((item, index) => {

      //console.log(`Item at index ${index}:`, item);
      if (item.amount_paid > 0) {
        totalMonthsToPay--;
        feesPaid += item.amount_paid;
      }
      if (item.amount_paid != null && item.amount_paid > this.case.expense.distribution_fee) {
        //console.log("Fully paid");
        //console.log(item.amount_paid);
        //console.log(fee);
        totalMonthsFullyPaid++;
      }
    });

    this.case.creditors.forEach((item, index) => {
      if (item.pivot.debt_amount > 0) {
        totalDebtAmount += Number(item.pivot.debt_amount);
      }

      //Ehem
      if (item.pivot.offer_to_creditor > 0) {
        totalCreditorsOffer += item.pivot.offer_to_creditor;
      }

      if (item.pivot.final_payment > 0) {
        totalFinalPayments += item.pivot.final_payment;
      }
    });

    return {
      DmTotalMonthsPending: totalMonthsToPay,
      DMfeePaid:            feesPaid,
      DMMonthsFeeFullyPaid: totalMonthsFullyPaid,
      DMTotalDebtAmount:    totalDebtAmount,
      totalCreditorsOffer,
      totalFinalPayments //,
      //DMbalance: balance
    };
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(selection, dataSource) {
    const numSelected = selection.selected.length;
    const numRows     = dataSource.data.length;

    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(selection, dataSource) {
    if (this.isAllSelected(selection, dataSource)) {
      selection.clear();
      return;
    }

    selection.select(...dataSource.data);
  }

  deletePayment($event, selectionPayment) {
    $event.preventDefault();
    const installment_ids = [];
    selectionPayment._selected.forEach(selected => installment_ids.push(selected.id));
    this.paymentService.deletePayments(this.case.id, installment_ids).pipe(finalize(() => this.isLoading--))
      .subscribe(
        value => {
          this.toastr.success(this.translate.instant('SHARED.item-deleted'));
        },
        error => {
          this.toastr.error(this.translate.instant('SHARED.went-wrong'));
        },
      );
  }

  mergeInstallments(selectionPayment) {
    const installmentIds = [];
    selectionPayment._selected.forEach(selected => installmentIds.push(selected.id));
    console.log(installmentIds);
    this.isLoading++;
    this.dataSource = new MatTableDataSource<PaymentTerm>([]);
    this.paymentService.mergeInstallments(this.case.id, installmentIds).pipe(finalize(() => this.isLoading--))
      .subscribe(
        value => {
          this.toastr.success('Installments merged');
          this.fetchInstallments(this.componentType);
        },
        error => {
          this.toastr.error(this.translate.instant('SHARED.went-wrong'));
        },
      );
  }

  public isElementRestricted() {
    if (this.authUser?.id === 1) {
      return true;
    }
    const enabledRoles         = environment.ALLOW_CASES_ROLES_IDS;
    const enabledStatusId      = environment.BLOCK_CASES_STATUS_IDS;
    const enabledDepartmentsId = environment.ALLOW_CASES_DEPARTMENTS_IDS;

    const isDepartmentAllowed = this.authUser.departments.some(department =>
      enabledDepartmentsId.includes(department.id)
    );

    if (
      ! enabledStatusId.includes(this.case.status_id) ||
      enabledRoles.includes(this.authUser.role_id) ||
      isDepartmentAllowed
    ) {
      return true;
    }
    return false;
  }

  hasMatchingCreditor(term: any): boolean {
    return this.case.unsecured_creditors.some(
      (creditor: any) => term.batches.name === creditor.name
    );
  }

  hasDistributionCaseTerms(): boolean {
    return this.case?.distribution_case_terms?.length > 0;
  }

  /*getUniqueCreditors(creditors: any[]): any[] {
    return creditors.filter((item, index, self) =>
      index === self.findIndex(t => t.id === item.id)
    );
  }*/

  isUnfifyePlan(element: any, creditor: any): boolean {
    const name             = element.name;
    const parts            = name.split(' ');
    const instalmentId     = parts[parts.length - 1];
    const instalmentNumber = Number(instalmentId);

    if (creditor.name !== 'UNIFYE' && element.name.includes('Phase 2') && ! isNaN(instalmentNumber)) {
      return Number(creditor.pivot.terms) >= instalmentNumber;
    }
    return true;
  }

  isBatchIncluded(term: any, element: any): boolean {
    // Ensure term.batches.id is treated as an array
    const batchIds = Array.isArray(term.batches?.id) ? term.batches.id : [term.batches?.id];

    // Ensure element.case.distribution is an array and extract the distribution_batch_id values
    const distributionBatchIds = Array.isArray(element.case.distribution)
      ? element.case.distribution.map((dist: any) => dist.distribution_batch_id)
      : [element.case.distribution?.distribution_batch_id];

    // Check if any batchIds exist in distributionBatchIds
    return batchIds.some((batchId: any) => distributionBatchIds.includes(batchId));
  }

  isMatchingFinalPhase(name: string, terms: number): boolean {
    const match = name.match(/Phase 2 - (\d+)/);
    if (match) {
      const phaseNumber = parseInt(match[1], 10);
      return phaseNumber === terms;
    }
    return false;
  }

  calculateSumsByPhase(element: any, creditors: any[]): { matchingPhaseSum: number } {
    let matchingPhaseSum   = element.amount;
    let elementName        = element.name;
    const parts            = elementName.split(' ');
    const instalmentId     = parts[parts.length - 1];
    const instalmentNumber = Number(instalmentId);

    creditors.forEach(creditor => {
      if ( ! creditor.pivot) return;
      if (this.excludedProductId.includes(creditor.pivot.product_id)) return;

      if (this.isMatchingFinalPhase(elementName, creditor.pivot.terms)) {
        if (creditor.pivot.final_payment) {
          matchingPhaseSum -= creditor.pivot.final_payment;
        }
      } else {
        if (creditor.pivot.offer_to_creditor) {
          if (instalmentNumber < creditor.pivot.terms) {
            matchingPhaseSum -= creditor.pivot.offer_to_creditor;
          } else {
            if (creditor.name == "UNIFYE") {
              matchingPhaseSum -= creditor.pivot.offer_to_creditor;
            }
          }
        }
      }
    });
    return {matchingPhaseSum};
  }

  getUniqueCreditors(term) {
    const displayed = new Set();
    return this.case.unsecured_creditors.filter(creditor => {
      if (term.batches.name === creditor.name && ! this.excludedProductId.includes(creditor.pivot.product_id)) {
        if ( ! displayed.has(creditor.name)) {
          displayed.add(creditor.name);
          return true;
        }
      }
      return false;
    });
  }

  hasMismatch(term): boolean {

    // Get all creditors (NOT unique ones) that match the term's batch name
    const matchingCreditors = this.case.unsecured_creditors.filter(creditor =>
      creditor.name === term.batches.name
    );

    // Check if at least one has a correct offer_to_creditor or final_payment
    const hasMatch = matchingCreditors.some(creditor => {
      return creditor.pivot.offer_to_creditor === term.amount_to_distribute ||
        creditor.pivot.final_payment === term.amount_to_distribute;
    });

    return ! hasMatch; // Return true if no matches found (show warning), false otherwise
  }

  private getPaymentPlanTypeGroups(): Array<AppSelectOption> {
    return [
      {label: this.translate.instant('PAYMENTS.payment_plan_group.options.debt_plan'), value: 'debt_plan'},
      {label: this.translate.instant('PAYMENTS.payment_plan_group.options.additional_plans'), value: 'additional_plans'}
    ];
  }

  public planTypeGroupsUpdated(productGroupSlugs: Array<'debt_plan' | 'additional_plans'>) {
    console.log(productGroupSlugs);

    const paymentPlanSlugs = [];
    productGroupSlugs.forEach(groupSlug => {
      this.paymentPlanTypes.forEach(product => {
        if (groupSlug === 'debt_plan' && product.slug === 'debt_plan') {
          paymentPlanSlugs.push(product.slug);
        } else if (groupSlug === 'additional_plans' && product.slug !== 'debt_plan') {
          paymentPlanSlugs.push(product.slug);
        }
      });
    });
    this.installmentsPlanTypeSlugsControl.patchValue(paymentPlanSlugs);
    this.onlyDebtPlanSelected      = productGroupSlugs.includes('debt_plan') && productGroupSlugs.length === 1;
    this.selectionPaymentsDisabled = !! (productGroupSlugs.includes('debt_plan') || productGroupSlugs.length === 0);
    this.forceDefaultProcessor     = productGroupSlugs?.length ? ! productGroupSlugs.includes('debt_plan') : false;
    this.installmentPlanTypeGroupChanged.emit(productGroupSlugs);
  }

  public deleteChildInstallment(termId: number, parentElement?: any): void {
    Swal.fire({
      title:              this.translate.instant('SHARED.warning'),
      text:               this.translate.instant('SHARED.action.delete_confirmation', {
        model: this.translate.instant('INSTALLMENTS.model_name.singular')
      }),
      icon:               'warning',
      showCancelButton:   true,
      confirmButtonText:  this.translate.instant('SHARED.delete'),
      cancelButtonText:   this.translate.instant('SHARED.cancel'),
      confirmButtonColor: '#886ab5',
    }).then(res => {
      if (res.isConfirmed) {
        this.isLoading++;

        this.paymentService.deleteCaseChildInstallment(this.case.id, termId)
          .pipe(finalize(() => this.isLoading--))
          .subscribe({
            next:  () => {
              this.toastr.success(this.translate.instant('SHARED.submit_result.delete.success', {
                model: this.translate.instant('INSTALLMENTS.model_name.singular'),
              }));

              if (parentElement && parentElement.child_installments_source) {
                const dataSource = parentElement.child_installments_source;
                dataSource.data  = dataSource.data.filter(
                  (installment: any) => installment.id !== termId
                );
              }
            },
            error: () => {
              this.toastr.error(this.translate.instant('SHARED.submit_result.delete.error', {
                model: this.translate.instant('INSTALLMENTS.model_name.singular'),
              }));
            }
          });
      }
    });
  }

}
